<form [formGroup]="labelPreparationSetupFormGroup" (ngSubmit)="onSubmit()">
    <div class="modal-dialog dw-modal" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3>
                    Label Preparation{{
                        labelPreparationSetupFormGroup.controls["name"].value !=
                        ""
                            ? ": " +
                              labelPreparationSetupFormGroup.controls["name"]
                                  .value
                            : ""
                    }}
                </h3>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="closeLabelPreparationSetupModal()"
                ></button>
            </div>
            <div class="modal-body">
                <div class="form-well">
                    <div class="mb-3 row">
                        <div class="col-12 col-lg-12">
                            <label class="form-control-label">Name *</label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="name"
                                placeholder="Give the Label Setup a name"
                            />
                            <div
                                *ngIf="
                                    labelPreparationSetupFormGroup.controls[
                                        'name'
                                    ].invalid &&
                                    (labelPreparationSetupFormGroup.controls[
                                        'name'
                                    ].dirty ||
                                        labelPreparationSetupFormGroup.controls[
                                            'name'
                                        ].touched)
                                "
                                class="alert alert-danger"
                            >
                                <small
                                    *ngIf="
                                        labelPreparationSetupFormGroup.controls[
                                            'name'
                                        ].errors?.required
                                    "
                                    class="text-danger"
                                >
                                    Label Setup Name is required.
                                </small>
                                <small
                                    *ngIf="
                                        labelPreparationSetupFormGroup.controls[
                                            'name'
                                        ].errors?.maxlength
                                    "
                                    class="text-danger"
                                >
                                    Label Setup name cannot be longer than 25
                                    characters.
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <div class="col-12 col-lg-12">
                            <label class="form-control-label"
                                >Last Updated</label
                            >
                            <input
                                type="text"
                                class="form-control form-control-input"
                                formControlName="lastUpdatedOn"
                            />
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <div class="col-12 col-lg-12">
                            <label class="form-control-label"
                                >Last Updated By</label
                            >
                            <input
                                type="text"
                                class="form-control form-control-input"
                                formControlName="lastUpdatedBy"
                            />
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <div class="col-12 col-lg-12">
                            <label class="form-control-label">Status</label>
                            <p-dropdown
                                [options]="statusOptions"
                                [styleClass]="'form-control form-control-input'"
                                [autofocusFilter]="false"
                                [editable]="false"
                                formControlName="status"
                            >
                            </p-dropdown>
                        </div>
                    </div>
                    <div>
                        <div class="mb-3 row">
                            <div class="col-12 col-lg-12">
                                <label class="form-control-label"
                                    >Export Form Questions & QR-Codes</label
                                >
                            </div>
                        </div>
                        <div class="mb-3 row">
                            <div class="col-12 col-lg-12">
                                <div class="form-well ql-editor ql-blank">
                                    <div class="p-3">
                                        <div class="row rowVital clearfix">
                                            <div class="col-12 col-lg-6">
                                                <h4>Questions</h4>
                                                <div class="form-well">
                                                    <div class="mb-3">
                                                        <p-multiSelect
                                                            appendTo="body"
                                                            [filter]="true"
                                                            [options]="
                                                                formQuestionOptions
                                                            "
                                                            optionLabel="label"
                                                            optionValue="id"
                                                            formControlName="selectedExportQuestions"
                                                            [(ngModel)]="
                                                                selectedExportQuestionId
                                                            "
                                                            placeholder="Select a Question"
                                                            autoDisplayFirst="true"
                                                            (onChange)="
                                                                addRemoveExportColumn(
                                                                    $event,
                                                                    true
                                                                )
                                                            "
                                                            [styleClass]="
                                                                'form-control form-to-export-question forms-multiselect'
                                                            "
                                                            [showClear]="false"
                                                            [maxSelectedLabels]="
                                                                10000
                                                            "
                                                            [autofocusFilter]="
                                                                false
                                                            "
                                                        >
                                                        </p-multiSelect>
                                                    </div>
                                                    <div
                                                        *ngIf="
                                                            labelPreparationSetupFormGroup
                                                                .controls[
                                                                'selectedExportQuestions'
                                                            ].invalid &&
                                                            (labelPreparationSetupFormGroup
                                                                .controls[
                                                                'selectedExportQuestions'
                                                            ].dirty ||
                                                                labelPreparationSetupFormGroup
                                                                    .controls[
                                                                    'selectedExportQuestions'
                                                                ].touched)
                                                        "
                                                        class="alert alert-danger"
                                                    >
                                                        <small
                                                            *ngIf="
                                                                labelPreparationSetupFormGroup
                                                                    .controls[
                                                                    'selectedExportQuestions'
                                                                ].errors
                                                                    ?.required
                                                            "
                                                            class="text-danger"
                                                        >
                                                            Question is
                                                            required.
                                                        </small>
                                                    </div>
                                                </div>
                                                <h4>QR Codes</h4>
                                                <div class="form-well">
                                                    <div class="mb-3">
                                                        <p-multiSelect
                                                            appendTo="body"
                                                            [filter]="true"
                                                            [options]="
                                                                labelPreparationQRCodeSetups
                                                            "
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            formControlName="selectedExportQRCodes"
                                                            [(ngModel)]="
                                                                selectedExportQRCodeId
                                                            "
                                                            placeholder="Select a QR Code"
                                                            autoDisplayFirst="true"
                                                            (onChange)="
                                                                addRemoveExportColumn(
                                                                    $event,
                                                                    false
                                                                )
                                                            "
                                                            [styleClass]="
                                                                'form-control form-to-export-question forms-multiselect'
                                                            "
                                                            [showClear]="false"
                                                            [maxSelectedLabels]="
                                                                10000
                                                            "
                                                            [autofocusFilter]="
                                                                false
                                                            "
                                                        >
                                                        </p-multiSelect>
                                                    </div>
                                                    <div
                                                        *ngIf="
                                                            labelPreparationSetupFormGroup
                                                                .controls[
                                                                'selectedExportQRCodes'
                                                            ].invalid &&
                                                            (labelPreparationSetupFormGroup
                                                                .controls[
                                                                'selectedExportQRCodes'
                                                            ].dirty ||
                                                                labelPreparationSetupFormGroup
                                                                    .controls[
                                                                    'selectedExportQRCodes'
                                                                ].touched)
                                                        "
                                                        class="alert alert-danger"
                                                    >
                                                        <small
                                                            *ngIf="
                                                                labelPreparationSetupFormGroup
                                                                    .controls[
                                                                    'selectedExportQRCodes'
                                                                ].errors
                                                                    ?.required
                                                            "
                                                            class="text-danger"
                                                        >
                                                            QR Code is required.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-12 clearfix d-lg-none"
                                            ></div>
                                            <div class="col-12 col-lg-6">
                                                <p-table
                                                    #dt
                                                    styleClass="label-questions-table"
                                                    [style]="{ width: '100%' }"
                                                    [value]="
                                                        selectedExportColumns
                                                    "
                                                    [columns]="
                                                        selectedQuesTableCols
                                                    "
                                                    [reorderableColumns]="true"
                                                    [scrollable]="true"
                                                    scrollHeight="250px"
                                                >
                                                    <ng-template
                                                        pTemplate="header"
                                                        let-columns
                                                    >
                                                        <tr>
                                                            <ng-container
                                                                *ngFor="
                                                                    let col of columns
                                                                "
                                                            >
                                                                <th
                                                                    *ngIf="
                                                                        col.visible !=
                                                                        false
                                                                    "
                                                                    pReorderableColumn
                                                                >
                                                                    {{
                                                                        col.header
                                                                    }}
                                                                </th>
                                                            </ng-container>
                                                            <th *ngIf="!isViewMode" class="label-questions-actions-col"></th>
                                                        </tr>
                                                        <tr>
                                                            <ng-container
                                                                *ngFor="
                                                                    let col of columns
                                                                "
                                                            >
                                                                <th
                                                                    *ngIf="
                                                                        col.visible !=
                                                                        false
                                                                    "
                                                                    [attr.colspan]="!isViewMode ? 2 : 1"
                                                                    pReorderableColumn
                                                                >
                                                                    <input
                                                                        pInputText
                                                                        type="text"
                                                                        style="width: 100%"
                                                                        [filterable]
                                                                        (input)="
                                                                            dt.filter(
                                                                                $event
                                                                                    .target
                                                                                    .value,
                                                                                col.field,
                                                                                'contains'
                                                                            )
                                                                        "
                                                                        class="p-column-filter"
                                                                    />
                                                                </th>
                                                            </ng-container>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template
                                                        pTemplate="body"
                                                        let-rowData
                                                        let-columns="columns"
                                                        let-index="rowIndex"
                                                    >
                                                        <tr
                                                            [pReorderableRow]="
                                                                index
                                                            "
                                                        >
                                                            <ng-container
                                                                *ngFor="
                                                                    let col of columns
                                                                "
                                                            >
                                                                <td
                                                                    *ngIf="
                                                                        col.visible !=
                                                                        false
                                                                    "
                                                                >
                                                                    {{
                                                                        rowData[
                                                                            col
                                                                                .field
                                                                        ]
                                                                    }}
                                                                </td>
                                                                <td
                                                                    *ngIf="
                                                                        !isViewMode &&
                                                                        col.visible !=
                                                                        false
                                                                    "
                                                                >
                                                                    <div
                                                                        class="align-right"
                                                                    >
                                                                        <div
                                                                            class="btn-group"
                                                                        >
                                                                            <input
                                                                                type="button"
                                                                                class="btn btn-secondary btn-sm d-block d-sm-block d-md-block d-lg-block d-xl-none"
                                                                                *ngIf="
                                                                                    index >
                                                                                    0
                                                                                "
                                                                                value="&#x2c4;"
                                                                                (click)="
                                                                                    onMoveUp(
                                                                                        index
                                                                                    )
                                                                                "
                                                                                title="Move Up"
                                                                                [disabled]="
                                                                                    isViewMode
                                                                                "
                                                                            />
                                                                            <input
                                                                                type="button"
                                                                                class="btn btn-secondary btn-sm d-block d-sm-block d-md-block d-lg-block d-xl-none"
                                                                                value="&#x2c5;"
                                                                                *ngIf="
                                                                                    index <
                                                                                    selectedExportColumns.length -
                                                                                        1
                                                                                "
                                                                                (click)="
                                                                                    onMoveDown(
                                                                                        index
                                                                                    )
                                                                                "
                                                                                title="Move Down"
                                                                                [disabled]="
                                                                                    isViewMode
                                                                                "
                                                                            />
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-secondary btn-sm d-none d-sm-none d-md-none d-lg-none d-xl-block"
                                                                                title="Drag & Move Question"
                                                                                [disabled]="
                                                                                    isViewMode
                                                                                "
                                                                                pReorderableRowHandle
                                                                            >
                                                                                Drag
                                                                                &
                                                                                Drop
                                                                            </button>
                                                                            <input
                                                                                type="button"
                                                                                class="btn btn-danger btn-sm"
                                                                                value="X"
                                                                                (click)="
                                                                                    removeItem(
                                                                                        index,
                                                                                        $event
                                                                                    )
                                                                                "
                                                                                title="Remove"
                                                                                [disabled]="
                                                                                    isViewMode
                                                                                "
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </ng-container>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <input
                    type="submit"
                    class="btn btn-success"
                    value="Save"
                    [hidden]="isViewMode"
                    [disabled]="labelPreparationSetupFormGroup.invalid"
                />
                <input
                    #closeLabelPreparationSetupButton
                    type="button"
                    class="btn btn-secondary"
                    value="Close"
                    (click)="closeLabelPreparationSetupModal()"
                />
            </div>
        </div>
    </div>
</form>
